import PropTypes from 'prop-types';
import React from 'react';
import styles from './style.module.scss';

const ColumnalTextDisplay = (props) => (
  <div className={`${styles.container} ${props.className || ''}`}>
    <div className={styles.inner}>
      <h3>{props.title}</h3>
      {props.children}
    </div>
  </div>
);

ColumnalTextDisplay.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  title: PropTypes.any,
};

ColumnalTextDisplay.defaultProps = {
  children: null,
  className: '',
  title: null,
};

export default ColumnalTextDisplay;
